import React, { useState, useEffect } from 'react';

export default function AdminDashboard() {
  const [registrations, setRegistrations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [page, setPage] = useState(1);
  const itemsPerPage = 10;

  useEffect(() => {
    fetchRegistrations();
  }, []);

  const fetchRegistrations = async () => {
    try {
      setLoading(true);
      const res = await fetch("https://tdtlworld.com/workshop_registration-backend/api/registrations/");
      if (!res.ok) throw new Error("Failed to fetch data");
      const data = await res.json();
      // Safely handle if data is an array or an object containing results
      setRegistrations(Array.isArray(data) ? data : (data.results || []));
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    try {
      const date = new Date(dateString);
      return new Intl.DateTimeFormat('en-US', {
        year: 'numeric', month: 'short', day: 'numeric',
        hour: '2-digit', minute: '2-digit'
      }).format(date);
    } catch (e) {
      return dateString;
    }
  };

  const totalPages = Math.ceil(registrations.length / itemsPerPage);
  const currentData = registrations.slice((page - 1) * itemsPerPage, page * itemsPerPage);

  return (
    <div style={{ padding: '40px 20px', minHeight: '100vh', background: '#0a0f18' }}>
      <div style={{ maxWidth: '1200px', margin: '0 auto', background: 'rgba(15, 23, 42, 0.4)', padding: '30px', borderRadius: '12px', border: '1px solid rgba(255, 255, 255, 0.05)' }}>
        <h2 style={{ color: '#fff', marginBottom: '20px', fontFamily: 'Michroma, sans-serif' }}>Registrations Dashboard</h2>
        
        {loading && (
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px', color: '#00F2FF' }}>
            <div className="spinner" style={{ width: '20px', height: '20px', border: '2px solid rgba(0, 242, 255, 0.3)', borderTop: '2px solid #00F2FF', borderRadius: '50%', animation: 'spin 1s linear infinite' }}></div>
            Loading registrations...
            <style>{`@keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }`}</style>
          </div>
        )}
        {error && <p style={{ color: '#e53e3e' }}>Error: {error}</p>}
        
        {!loading && !error && (
          <div style={{ overflowX: 'auto' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse', color: '#fff', fontSize: '0.9rem' }}>
              <thead>
                <tr style={{ borderBottom: '2px solid #00F2FF', textAlign: 'left' }}>
                  <th style={{ padding: '12px' }}>Name</th>
                  <th style={{ padding: '12px' }}>Phone</th>
                  <th style={{ padding: '12px' }}>Email</th>
                  <th style={{ padding: '12px' }}>School Name</th>
                  <th style={{ padding: '12px' }}>Location</th>
                  <th style={{ padding: '12px' }}>Date</th>
                </tr>
              </thead>
              <tbody>
                {currentData.length > 0 ? currentData.map((reg, idx) => (
                  <tr key={idx} style={{ borderBottom: '1px solid rgba(255, 255, 255, 0.1)' }}>
                    <td style={{ padding: '12px' }}>{reg.name}</td>
                    <td style={{ padding: '12px' }}>{reg.phone}</td>
                    <td style={{ padding: '12px' }}>{reg.email}</td>
                    <td style={{ padding: '12px' }}>{reg.schoolName || 'N/A'}</td>
                    <td style={{ padding: '12px' }}>{reg.location || 'N/A'}</td>
                    <td style={{ padding: '12px', color: '#A0AEC0' }}>{formatDate(reg.created_at || reg.createdAt || reg.date)}</td>
                  </tr>
                )) : (
                  <tr>
                    <td colSpan="6" style={{ padding: '20px', textAlign: 'center', color: '#A0AEC0' }}>No registrations found.</td>
                  </tr>
                )}
              </tbody>
            </table>

            {/* Pagination Controls */}
            {totalPages > 1 && (
              <div style={{ display: 'flex', justifyContent: 'center', gap: '15px', marginTop: '20px', alignItems: 'center' }}>
                <button 
                  onClick={() => setPage(p => Math.max(1, p - 1))}
                  disabled={page === 1}
                  style={{ padding: '8px 16px', background: 'transparent', border: '1px solid #00F2FF', color: '#00F2FF', borderRadius: '4px', cursor: page === 1 ? 'not-allowed' : 'pointer', opacity: page === 1 ? 0.5 : 1 }}
                >
                  Previous
                </button>
                <span style={{ color: '#fff' }}>Page {page} of {totalPages}</span>
                <button 
                  onClick={() => setPage(p => Math.min(totalPages, p + 1))}
                  disabled={page === totalPages}
                  style={{ padding: '8px 16px', background: 'transparent', border: '1px solid #00F2FF', color: '#00F2FF', borderRadius: '4px', cursor: page === totalPages ? 'not-allowed' : 'pointer', opacity: page === totalPages ? 0.5 : 1 }}
                >
                  Next
                </button>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
